import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../../../../components/PageLayout/CheckBox';
export default function () {
    function onChecked1(stone, stoneIndex) {
        this.selectStone(stone);
    }
    function repeatStone2(stone, stoneIndex) {
        return React.createElement('li', {
            'className': 'assign-popup-selected-stones__list-item',
            'key': stone.id
        }, React.createElement(CheckBox, {
            'onChecked': onChecked1.bind(this, stone, stoneIndex),
            'checked': this.isSelected(stone),
            'innerStyle': 'grey',
            'text': this.getName(stone)
        }));
    }
    function onChecked3(stone, stoneIndex) {
        this.selectProfileAssignedStone(stone);
    }
    function repeatStone4(stone, stoneIndex) {
        return React.createElement('li', {
            'className': 'assign-popup-selected-stones__list-item',
            'key': stone.id
        }, React.createElement(CheckBox, {
            'onChecked': onChecked3.bind(this, stone, stoneIndex),
            'checked': this.isProfileAssignedSelected(stone),
            'innerStyle': 'grey',
            'text': this.getName(stone)
        }));
    }
    function onClick5() {
        this.selectPreset({ id: null });
    }
    function onClick6(preset, presetIndex) {
        {
            this.selectPreset(preset);
        }
    }
    function repeatPreset7(preset, presetIndex) {
        return [React.createElement('li', {
                'className': 'assign-popup-algorithm-list__item ' + (this.state.selectedPreset && this.state.selectedPreset.id == preset.id ? 'selected' : ''),
                'onClick': onClick6.bind(this, preset, presetIndex),
                'key': '24081'
            }, React.createElement('span', {
                'style': { backgroundImage: 'url(' + preset.icon + ')' },
                'className': 'assign-popup-algorithm-list__item-image'
            }), React.createElement('span', { 'className': 'assign-popup-algorithm-list__item-title' }, preset.name))];
    }
    return React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Assign Pricing Profiles')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'assign-popup' }, React.createElement('div', { 'className': 'assign-popup-content' }, React.createElement('div', { 'className': 'assign-popup-content__left' }, React.createElement('div', { 'className': 'assign-popup-title' }, 'Selected Stones'), React.createElement('div', { 'className': 'assign-popup-selected-stones' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-popup-selected-stones__list ui-list' },
        _.map(this.props.assignPricingProfileStones, repeatStone2.bind(this))
    ]), this.props.stonesAssignedToSelectedProfile.length > 0 ? React.createElement('div', {
        'className': 'assign-popup-title',
        'key': '1049'
    }, 'Stones assigned to Selected Preset') : null, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-popup-selected-stones__list ui-list' },
        _.map(this.props.stonesAssignedToSelectedProfile, repeatStone4.bind(this))
    ]))), React.createElement('div', { 'className': 'assign-popup-content__right' }, React.createElement('div', { 'className': 'assign-popup-title' }, 'Assign Algorithm'), React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-popup-algorithm-list' },
        React.createElement('li', {
            'className': 'assign-popup-algorithm-list__item ' + (this.state.selectedPreset && this.state.selectedPreset.id == null ? 'selected' : ''),
            'onClick': onClick5.bind(this)
        }, React.createElement('span', {
            'style': { backgroundImage: 'url(\'../content/views/dashboard/images/AlgorithmRemove.svg\')' },
            'className': 'assign-popup-algorithm-list__item-image'
        }), React.createElement('span', { 'className': 'assign-popup-algorithm-list__item-title' }, 'Remove Algorithm')),
        _.map(this.props.presets, repeatPreset7.bind(this))
    ]))))), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', { 'className': 'ui-button ui-button--blue' }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': this.props.closeAssignPopup
    }, 'Cancel')), React.createElement('button', { 'className': 'ui-button ui-button--green' }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': this.assignPricing
    }, 'Assign'))));
}